const getSnackBar = state => {
  return {
    display: state.snackBarDisplay,
    color: state.snackBarColor,
    text: state.snackBarText
  }
}

const getSettingsDrawer = state => state.settingsDrawer
const rightDrawer = state => state.rightDrawer
const leftDrawer = state => state.leftDrawer
const guestLeftDrawer = state => state.guestLeftDrawer
const token = state => state.token
const getLoadingDialog = state => state.loadingDialog
const getTourCurrentStep = state => state.tourCurrentStep
const getDashboardTourStart = state => state.dashboardTourStart
const getPageTitle = state => state.pageTitle
const getDbObject = state => state.dbObject
const getLevelsCount = state => state.levelsCount
const getLoadingCourseDialog = state => state.loadingCourseDialog
const getLoadingCourseDialogMsg = state => state.loadingCourseDialogMsg
const getNewUserLoggedIn = state => state.newUserLoggedin
const getRefreshHomePage = state => state.refreshHomePage
const getTourStatus = state => state.tourStatus
const getLearnStatus = state => state.learnStatus
const getQuizStatus = state => state.quizStatus
const getRssFeed = state => state.rssFeedNews
// const getNewsDialog = state => state.newsDialog
// const getAllNewsDialog = state => state.allNewsDialog
// const getUserSeenNewsOnDate = state => state.userSeenNewsOnDate
// const getNewsFetched = state => state.newsFetched
const getAppHeight = state => state.appHeight
const getAppWidth = state => state.appWidth
const getIsCompactHeader = state => state.isCompactHeader
const getMobileStatusBarStatus = (state) => state.mobileStatusBarStatus

export {
  getSnackBar,
  getSettingsDrawer,
  rightDrawer,
  leftDrawer,
  guestLeftDrawer,
  getLoadingDialog,
  token,
  getTourCurrentStep,
  getDashboardTourStart,
  getPageTitle,
  getDbObject,
  getLevelsCount,
  getLoadingCourseDialog,
  getLoadingCourseDialogMsg,
  getNewUserLoggedIn,
  getTourStatus,
  getLearnStatus,
  getQuizStatus,
  getRssFeed,
  // getNewsDialog,
  // getAllNewsDialog,
  // getUserSeenNewsOnDate,
  getIsCompactHeader,
  getAppHeight,
  getAppWidth,
  getRefreshHomePage,
  getMobileStatusBarStatus
}



// WEBPACK FOOTER //
// ./src/store/getters.js